import { render, staticRenderFns } from "./insureInfoModal.vue?vue&type=template&id=ca1fe552&scoped=true"
import script from "./insureInfoModal.vue?vue&type=script&lang=js"
export * from "./insureInfoModal.vue?vue&type=script&lang=js"
import style0 from "./insureInfoModal.vue?vue&type=style&index=0&id=ca1fe552&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1fe552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca1fe552')) {
      api.createRecord('ca1fe552', component.options)
    } else {
      api.reload('ca1fe552', component.options)
    }
    module.hot.accept("./insureInfoModal.vue?vue&type=template&id=ca1fe552&scoped=true", function () {
      api.rerender('ca1fe552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insure/components/insureInfoModal.vue"
export default component.exports